import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { orgId, loadRemoteManifest, Ajax } from 'utils';
import { loadRemoteStyle } from 'utils/loadRemoteComponent';
import { ajaxLoading } from 'utils/Ajax';

import { GlobalContext, I18NContext } from 'commons';

const loadRemoteIncidentSubStyles = async () => {
  // eslint-disable-next-line max-len
  const url = '/static_mbr_incident_sub/static/manifest.json'
  const result = await Ajax.get(url);
  const incidentSubCssUrl = result.data['incident-sub.css'];

  if (incidentSubCssUrl) {
    loadRemoteStyle({ href: incidentSubCssUrl });
  }
};

const IncidentSubscriptions = ({
  contactId,
  csrfToken,
  accountName,
  viewName,
  setLoadingIncSubs,
  lang,
  setSaveIncSubAssignments,
}) => {
  const [IncidentSubscriptionsComponent, setIncidentSubscriptionsComponent] = useState();
  loadRemoteIncidentSubStyles();

  useEffect(() => {
    ajaxLoading.show();
    // eslint-disable-next-line max-len
    const url = '/static_mbr_incident_sub/static/manifest.json'

    loadRemoteManifest({
      url,
      callback: component => {
        ajaxLoading.show();
        setIncidentSubscriptionsComponent(component);
        setLoadingIncSubs(false);
      },
    });
  }, []);

  useEffect(() => {
    if (IncidentSubscriptionsComponent) {
      ajaxLoading.show();
      setTimeout(() => {
        ajaxLoading.hide();
      }, 1500);
    }
  }, [IncidentSubscriptionsComponent]);

  if (!IncidentSubscriptionsComponent) {
    return null;
  }

  return (
    <div className="ita-member-incident-sub-root">
      <IncidentSubscriptionsComponent
        viewName={viewName}
        contactId={contactId}
        orgId={orgId}
        csrfToken={csrfToken}
        userName={accountName}
        lang={lang}
        setSaveAssignments={setSaveIncSubAssignments}
      />
    </div>
  );
};

IncidentSubscriptions.propTypes = {
  contactId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  setLoadingIncSubs: PropTypes.func,
  csrfToken: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
  viewName: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  setSaveIncSubAssignments: PropTypes.func,
};

IncidentSubscriptions.defaultProps = {
  setLoadingIncSubs: () => {},
  setSaveIncSubAssignments: (fnOnDone) => {
    if (fnOnDone) {
      fnOnDone();
    }
  },
};

export default IncidentSubscriptions;
